import { render, staticRenderFns } from "./LocationAdditionalCharges.vue?vue&type=template&id=64921660&scoped=true&"
import script from "./LocationAdditionalCharges.vue?vue&type=script&lang=js&"
export * from "./LocationAdditionalCharges.vue?vue&type=script&lang=js&"
import style0 from "./LocationAdditionalCharges.vue?vue&type=style&index=0&id=64921660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64921660",
  null
  
)

export default component.exports